import React from 'react'
import { Row, Tooltip, Typography } from 'antd'
import { Icon } from '@iconify/react'

const { Text, Link } = Typography

const FilePreview = ({ file, index, token, handleDownload }) => {
    const getFileName = (url) => {
        try {
            return decodeURIComponent(url?.split('/').pop())
        } catch (e) {
            return 'Unknown'
        }
    }

    const renderFileInfo = (icon, typeLabel) => {
        const fileName = getFileName(file?.src)
        const isLongName = fileName?.length > 14

        return (
            <Row
                style={{
                    maxWidth: 240,
                    height: 66,
                    borderRadius: 6,
                    border: '1px solid #edeae9',
                    padding: '14px 30px 14px 6px',
                }}
                align="middle"
            >
                <Row align="middle" style={{ columnGap: 10 }}>
                    <Icon icon={icon} width={34} height={34} color="gray" />
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        {isLongName ? (
                            <Tooltip
                                title={fileName}
                                arrow={false}
                                placement="bottom"
                                classNames={{ body: 'tooltip-global' }}
                            >
                                <Text
                                    style={{
                                        textTransform: 'capitalize',
                                        fontWeight: token?.fontWeightStrong,
                                        cursor: 'pointer',
                                        display: 'block',
                                    }}
                                    ellipsis={{ rows: 1 }}
                                >
                                    {fileName.substring(0, 14) + '...'}
                                </Text>
                            </Tooltip>
                        ) : (
                            <Text
                                style={{ textTransform: 'capitalize' }}
                                ellipsis={{ rows: 1 }}
                            >
                                {fileName}
                            </Text>
                        )}
                        <Row
                            align="middle"
                            style={{
                                columnGap: 4,
                                color: '#6D6E6F',
                                fontSize: 12,
                            }}
                        >
                            <Text
                                style={{
                                    textTransform: 'capitalize',
                                    color: '#6D6E6F',
                                    fontSize: 12,
                                }}
                            >
                                {typeLabel}
                            </Text>
                            <Text>·</Text>
                            <Link
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleDownload?.(file)
                                }}
                            >
                                Download
                            </Link>
                        </Row>
                    </div>
                </Row>
            </Row>
        )
    }

    if (file.type === 'video') {
        return renderFileInfo('lets-icons:video-file-fill', 'Video File')
    }

    if (file.type === 'pdf') {
        return renderFileInfo('material-icon-theme:pdf', 'PDF File')
    }

    if (file.type === 'svg') {
        return renderFileInfo('fa6-solid:file-image', 'SVG File')
    }

    if (file.type === 'image') {
        return (
            <img
                src={file.src}
                alt={`thumb-${index}`}
                style={{
                    width: 'fitContent',
                    minWidth: 60,
                    height: 66,
                    objectFit: 'cover',
                    borderRadius: 6,
                    border: '1px solid #edeae9',
                }}
            />
        )
    }

    return (
        <div
            style={{
                width: 'fitContent',
                minWidth: 60,
                height: 66,
                backgroundColor: '#444',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                borderRadius: 6,
                border: '1px solid #edeae9',
            }}
        >
            {file.type?.toUpperCase()}
        </div>
    )
}

export default FilePreview
